import { render } from "./TreemapChart.vue?vue&type=template&id=012d6d80&scoped=true"
import script from "./TreemapChart.vue?vue&type=script&lang=js"
export * from "./TreemapChart.vue?vue&type=script&lang=js"

import "./TreemapChart.vue?vue&type=style&index=0&id=012d6d80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012d6d80"]])

export default __exports__